<div class="list-collection-request">
  @if (loading) {
  <div class="loading-state">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Loading collection requests...</p>
  </div>
  } @else if (error) {
  <div class="error-state">
    <p class="error-message">{{ error }}</p>
  </div>
  } @else if (paginatedResponse?.docs?.length === 0) {
  <div class="empty-state">
    <p>No collection requests yet.</p>
  </div>
  } @else {
  <div class="flex flex-col gap-2">
    @for (request of paginatedResponse?.docs ?? []; track trackById($index, request)) {
    <div class="bg-white rounded-md p-2 flex flex-col cursor-pointer" (click)="onItemClick(request)">

      <div class="flex flex-row justify-between items-start w-full p-2">
        <p class="text-sm text-gray-600">{{ request.createTime | date:'medium' }}</p>

        @switch(request.shareStatus) {
        @case('open') {
        <p class="text-sm text-amber-600">Pending</p>
        }
        @case('completed') {
        <p class="text-sm text-green-700">Completed</p>
        }
        @case('cancelled') {
        <p class="text-sm text-gray-600">Cancelled</p>
        }
        }

      </div>

      <p class="text-left text-gray-600 m-2">{{request.template?.purpose}}</p>

      <div class="flex flex-row gap-2 items-center justify-between border-t border-gray-200 p-2 w-full">
        <p class="text-sm text-gray-600 text-nowrap flex-1 overflow-hidden text-ellipsis">
          {{ getCollectUrl(request._id) }}</p>
        <ion-icon name="copy-outline" class="text-gray-600 cursor-pointer"
          (click)="$event.stopPropagation(); onCopyLink(request._id)"></ion-icon>
      </div>

    </div>
    }
  </div>
  }
</div>